module.exports = __webpack_public_path__ + "static/img/new_building.e8eba8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_building.jpg
// module id = RrmT
// module chunks = 0